const brandReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default brandReducer;